var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChangeLiveScreen = function SvgChangeLiveScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    x: 1,
    y: 1,
    stroke: "currentColor",
    strokeWidth: 2,
    rx: 29
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 26,
    fill: "currentColor",
    opacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30 20c4.924 0 9.028 3.523 9.875 8.163h1.048c.752 0 .943.644.533 1.184l-2.352 3.134c-.295.407-.81.407-1.105 0l-2.352-3.134c-.4-.54-.21-1.184.534-1.184h1.123A7.505 7.505 0 0 0 30 22.49c-1.875 0-3.59.71-4.856 1.875-.733.53-1.39.34-1.78-.086-.43-.483-.486-1.306.19-1.827A9.6 9.6 0 0 1 30 20m0 20c-4.913 0-9.017-3.523-9.875-8.163h-1.038c-.761 0-.952-.644-.542-1.184l2.361-3.134c.296-.407.8-.407 1.105 0l2.343 3.134c.4.54.219 1.184-.534 1.184h-1.123c.809 3.258 3.77 5.673 7.304 5.673a7.2 7.2 0 0 0 4.866-1.875c.723-.53 1.39-.35 1.77.085.43.483.486 1.297-.19 1.827A9.66 9.66 0 0 1 30 40"
  })));
};
export default SvgChangeLiveScreen;